<template>
  <div v-loading="loading" class="h-100 container project-edit-container">
    <!--  订单信息    -->
    <part-base ref="partBase" :key="'base' + key" :form-data.sync="formData"
               :show-add-btn="!!$route.query.id"
               :pt="parseInt($route.query.pt)"
               :is-pre-executor="parseInt($route.query.isPreExecutor) === 1"
               @saved="saved"
               @goBack="goBack"
               @refresh="getOrderDetail"/>

    <!-- 直播数据 -->
    <template v-if="userAuth.order_live_data_info&&formData.order_no">
      <live-data-money v-if="formData.money_or_times==='money'" :order-id="id" :order-no="formData.order_no"
                       :artist-id="formData.artist_id" :is-done-order="formData.is_done_order"/>
      <live-data-time v-else :order-id="id"/>
    </template>

    <!--  子订单信息  -->
    <child-orders :key="'orders' + key" :pid="id" :project="formData"/>

    <!--  财务部分  -->
    <part-finance :key="'finance' + key" :order-id="formData.id" v-if="userAuth.view_adv_order_finance_div&&formData.id"
                  :show-divide="false"
                  style="margin-top: 10px"/>

    <!--    &lt;!&ndash;    是否完结&ndash;&gt;-->
    <!--    <part-order-status :order-id="id"  v-if="userAuth.can_done_adv_order" :order-status="formData.is_done_order"></part-order-status>-->

    <!-- 底部固定按钮 -->
    <div v-permission="'option_revoke_undo_adv_order'" class="fixed-bottom-container"
         v-if="formData.id&&parseInt(formData.bool_undo)===1">
      <div class="fixed-bottom-content">
        <el-button class="withdraw-btn" type="primary" @click="handleRevokeUndo">撤回撤单，恢复正常</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import PartBase from "./components/PartBase";
import ChildOrders from "./components/PartChildOrders";
import {getOrderDetailBase} from "@/api/order";
import PartFinance from "@/views/adOrder/components/detail/PartFinance";
import LiveDataTime from "@/views/adOrder/project/components/LiveDataTime.vue";
import LiveDataMoney from "./components/LiveDataMoney.vue";
import {doOrdersRevokeUndo} from "@/api/adOrder";

// 表单数据结构
const ModelFormData = {
  is_mark: 1,
  company_id: null, // 乙方
  customer_name: '', //客户姓名
  customer_nature: '', //客户性质
  customer_id: '', // 客户ID
  customer_name_custom: null,
  exec_customer_id: null, // 执行公司id
  exec_customer_name: '', // 执行公司名称
  sale: '', //销售
  sale_id: '', // 销售ID
  executor: '', // 执行
  executor_id: '', // 执行ID
  brand: '', // 选中的代理品牌
  combine_brand_id: null,
  combine_brand_name: null,
  combine_id: '', // 集团ID
  combine_name: '', // 集团名称
  organization_id: '', // 小组ID
  organization_name: '', // 小组名称
  trade: '', // 行业
  product: '', // 产品
  order_source: '', // 订单来源
  form_of_cooperation: '', // 合作形式
  product_category: '', // 品类
  passenger_order_interval: '', // 客单
  remark_ffc: '',//合作形式备注：全案营销的时候显示
  project_name: null,
  strategy_name: null, // 策略人名
  strategy_id: null, // 策略人ID
  planner_name: null, // 策划人名
  planner_id: null, // 策划人ID
  medium_name: null, // 媒介人
  medium_id: null, // 媒介人ID
  commerce: null, // 招商
  commerce_id: null, // 招商人ID
  payment_account: 0, // 含税收入
  tax_point: 6, // 税点
  remark: '', //备注
  money_or_times: null,// 保量/保次
  //其他
  order_type: 'regular', //订单类型：regular【普通订单】、strike【冲账订单】,
  //项目是否完结
  is_done_order: 0,
  //红人
  artist_ids: [],
  artist_nms: [],
};
export default {
  name: "Edit",
  components: {LiveDataMoney, LiveDataTime, PartFinance, PartBase, ChildOrders},
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth
    },
  },
  data() {
    return {
      id: null,
      key: new Date().getTime(),
      loading: false,
      formData: {...{}, ...ModelFormData},

    }
  },
  created() {
    this.id = this.$route.params && this.$route.params.id;
    this.getOrderDetail()
  },
  methods: {
    async refresh() {
      await this.getOrderDetail()
      this.key = new Date().getTime()
    },
    handleRevokeUndo: function () {
      const row = this.formData;
      let msg = `订单编号：${row.order_no} 客户：${row.customer_name} 建单人：${row.creator || row.creator_name} `

      let that = this;
      this.showModal({
        h: this,
        text: msg + "，确定撤回撤单吗？",
        confirmText: "",
        cancelText: "",
        confirm: async function () {
          that.loading = true
          const response = await doOrdersRevokeUndo({id: row.id});
          that.loading = false
          if (!response.success) {
            that.$notify.warning({title: '提示', message: response.message});
            return false
          }
          that.showToast({
            h: that,
            icon: "el-icon-success",
            text: "操作成功",
            duration: 2000
          });
          setTimeout(() => {
            that.refresh()
          }, 2000)
        }
      });
    },
    goBack() {
      this.$router.push({name: "ad-wcm"});
    },
    //修改订单后
    saved() {
      this.showToast({
        h: this,
      })
      this.key = new Date().getTime()
      window.location.reload()
    },
    async getOrderDetail() {
      this.loading = true
      //获取订单信息 getOrderDetailBase
      const {model} = await getOrderDetailBase({id: this.id})
      this.loading = false
      const formData = model.info
      if (formData.is_quantity === 'Y') {
        formData.money_or_times = 'money'
      } else if (formData.is_quantity_times === 'Y') {
        formData.money_or_times = 'times'
      } else {
        formData.money_or_times = 'none'
      }
      this.formData = formData
      this.$refs.partBase.initOldCustomerData(this.formData)
    },
  }
}
</script>
<style lang="scss">
.project-edit-container {

  .form-rows {
    border: 1px solid rgb(221, 221, 221);
    border-radius: 6px;
    padding: 20px;
  }

  .card-title {
    position: relative;
    padding-left: 55px;
    margin-bottom: 8px;
    color: rgba(50, 50, 50, 1);
    line-height: 24px;
    font-size: 14px;
    font-weight: bold;
    text-align: left;
  }

  .card-title::after {
    content: "";
    position: absolute;
    bottom: 6.5px;
    left: calc(55px - 8px - 6px);
    width: 8px;
    height: 8px !important;
    background: rgba(224, 63, 61, 1);
    border-radius: 2px;
  }
  /* 底部固定容器 */
  .fixed-bottom-container {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-top: 1px solid rgba(221, 221, 221, 0.5);
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    padding: 16px 0;
  }
  /* 底部固定内容 */
  .fixed-bottom-content {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  /* 撤回撤单按钮 */
  .withdraw-btn {
    background-color: #ff0000 !important;
    border-color: #ff0000 !important;
    color: #ffffff !important;
    font-weight: 500;
    font-size: 14px;
    padding: 12px 32px;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(255, 0, 0, 0.3);
    transition: all 0.3s ease;
    min-width: 120px;
  }

  .withdraw-btn:hover {
    background-color: #e60000 !important;
    border-color: #e60000 !important;
    box-shadow: 0 6px 16px rgba(255, 0, 0, 0.4);
    transform: translateY(-1px);
  }

  .withdraw-btn:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(255, 0, 0, 0.3);
  }

}

</style>
